import React from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import Navbar from '../Nav';
import './blog.css';
import { posts } from './posts';

function BlogPost() {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="blog-page">
        <Navbar />
        <main className="blog-wrapper">
          <p className="blog__label">Blog</p>
          <h1 className="blog__title">Post not found</h1>
          <Link className="blog__item" to="/blog">
            ← Back to blog
          </Link>
        </main>
      </div>
    );
  }

  return (
    <div className="blog-page">
      <Navbar />
      <main className="blog-wrapper">
        <p className="blog__label">Blog</p>
        <h1 className="blog__title">{post.title}</h1>
        <p className="blog__date">{post.date}</p>
        <p className="blog__summary blog__summary--detail">{post.summary}</p>
        <article className="blog__content">
          {post.content.map((para, idx) => (
            <div key={idx} className="blog__markdown">
              <ReactMarkdown>{para}</ReactMarkdown>
            </div>
          ))}
        </article>
        <Link className="blog__item" to="/blog">
          ← Back to blog
        </Link>
      </main>
    </div>
  );
}

export default BlogPost;
